export const LANGUAGES = {
  EN: { code: 'en', label: 'English' },
  FR: { code: 'fr', label: 'Français' },
};

export const PAYMENT_AMOUNT_LIMITS = {
  MIN: 1,
  MAX: 50000,
};

/**
 * Steps throughout the payment process.
 * @readonly
 * @enum {1|2|3|4|5|6}
 */
export const STEP = Object.freeze({
  /** Payment Recipient */
  CHOOSE_PARTNER: 1,
  DETAILS: 2,
  PAYMENT_OPTION: 3,
  REVIEW: 4,
  MAKE_PAYMENT: 5,
  CONFIRMATION: 6,
});

export const DEFAULT_ACCOUNT_NAME_MAX_LENGTH = 50;
